package org.solyton.solawi.bid.module.control.button

import androidx.compose.runtime.Composable
import org.evoleq.compose.Markup
import org.evoleq.compose.style.data.device.DeviceType
import org.evoleq.math.Source
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Color
@Markup
@Composable
@Suppress("FunctionName")
fun AnglesLeftButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-angles-left"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)
@Markup
@Composable
@Suppress("FunctionName")
fun AnglesRightButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-angles-right"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)
@Markup
@Composable
@Suppress("FunctionName")
fun AppsButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-grip"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun ArrowUpButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-arrow-up"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun BanButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-ban"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)
@Markup
@Composable
@Suppress("FunctionName")
fun BuildingColumnsButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-building-columns"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun BulkEditButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-list-check"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun CheckButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    // fa-list-check
    //"fa-check-square"),
    arrayOf("fa-solid", "fa-check"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)


@Markup
@Composable
@Suppress("FunctionName")
fun ChevronDownButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    // fa-list-check
    //"fa-check-square"),
    arrayOf("fa-solid", "fa-chevron-down"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)


@Markup
@Composable
@Suppress("FunctionName")
fun ChevronLeftButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    // fa-list-check
    //"fa-check-square"),
    arrayOf("fa-solid", "fa-chevron-left"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)


@Markup
@Composable
@Suppress("FunctionName")
fun ChevronRightButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    // fa-list-check
    //"fa-check-square"),
    arrayOf("fa-solid", "fa-chevron-right"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)


@Markup
@Composable
@Suppress("FunctionName")
fun ChevronUpButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    // fa-list-check
    //"fa-check-square"),
    arrayOf("fa-solid", "fa-chevron-up"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun ClockButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-clock"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun CodeMergeButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-code-merge"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)


@Markup
@Composable
@Suppress("FunctionName")
fun CoinsButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-coins"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun CommentButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-comment"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun CommentDollarButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-comment-dollar"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun CreditCardButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-credit-card"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun DetailsButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,

    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-file-lines"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun DownloadButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-download"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun EditButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-pen"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun EnvelopeCircleCheckButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-envelope-circle-check"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)
@Markup
@Composable
@Suppress("FunctionName")
fun EvaluationButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-chart-line"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun FileExportButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-file-export"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)
@Markup
@Composable
@Suppress("FunctionName")
fun FileImportButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-file-import"), //"fa-file-arrow-up"
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun GearButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-gear"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun HelpButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-question"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun HomeButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-house"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun PlayButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-play"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun PlusButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-plus"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun SackDollarButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-sack-dollar"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun SackXMarkButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-sack-xmark"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun ScrewDriverWrenchButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-screwdriver-wrench"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)


@Markup
@Composable
@Suppress("FunctionName")
fun ShareNodesButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-share-nodes"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun SquareCheckButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-square-check"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun SupportButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-life-ring"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun TrashCanButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-trash-can"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun UploadButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-upload"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun UsersButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-users"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun UserLockButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-user-lock"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)


@Markup
@Composable
@Suppress("FunctionName")
fun UserGearButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-user-gear"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)

@Markup
@Composable
@Suppress("FunctionName")
fun XMarkButton(
    color: CSSColorValue,
    bgColor: CSSColorValue = Color.transparent,
    texts: Source<String?> = {null},
    deviceType: Source<DeviceType>,
    isDisabled: Boolean = false,
    dataId: String? = null,
    onClick: ()->Unit
) = IconButton(
    color,
    bgColor,
    arrayOf("fa-solid", "fa-xmark"),
    texts,
    deviceType,
    isDisabled,
    dataId,
    onClick
)
